import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { Col, Row } from 'antd'

import AntdEmpty, { PRESENTED_IMAGE_SIMPLE } from 'common/components/dataDisplay/Empty'
import Button from 'common/components/general/Button'

import { DESIGN_BENEFIT_PATH } from '../design'

import '../BenefitDetailsStyles.less'

interface EmptyProps {
  planPeriodId: string
}

const SummaryEmpty: React.FC<EmptyProps> = ({ planPeriodId }) => {
  const history = useHistory()
  const match = useRouteMatch()
  const { t: translate } = useTranslation()

  return (
    <Row className="benefit_details__empty">
      <Col span={24}>
        <AntdEmpty image={PRESENTED_IMAGE_SIMPLE} description={false} />
      </Col>
      <Col className="summary" span={24}>
        <h5 className="title">{translate('admin-dashboard.benefit-details.empty.title')}</h5>
        <Button
          type="primary"
          className="button"
          onClick={() => {
            history.push(`${match.path}/${DESIGN_BENEFIT_PATH}/${planPeriodId}`)
          }}
        >
          {translate('admin-dashboard.benefit-details.empty.design-benefit-button')}
        </Button>
      </Col>
    </Row>
  )
}

export default SummaryEmpty
